import React from 'react'
import {BannerHomeItemDetalle} from './BannerHomeItemDetalle'

function BannerHomeItem(props) {

  const displayItems = (props) => {
    const banners = props.bannersHome

    if (props) {
      if (banners) {
        if (banners.length > 0) {
          return banners.map((bannerHome, index) => {
            return (
              <BannerHomeItemDetalle
                key={index}
                bannerHome={bannerHome}
                deleteBannerHome={props.deleteBannerHome}
              />
            )
          })
        } else {
          return <h3>No hay banners</h3>
        }
      } else {
        return <h3>No hay banners</h3>
      }
    } else {
      return <h3>No hay banners</h3>
    }
  }
  return <>{displayItems(props)}</>
}

export {BannerHomeItem}
